module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('md-dialog', {
    ref: "deletePage",
    attrs: {
      "md-open-from": "#deletePage",
      "md-close-to": "#deletePage"
    },
    on: {
      "open": _vm.fixContent,
      "close": _vm.startOver
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('div', {
    staticStyle: {
      "padding": "14px",
      "padding-bottom": "0px"
    }
  }, [_c('md-dialog-content', [_c('p', [_vm._v("Delete Page")]), _vm._v(" "), _c('div', {
    staticClass: "from-to-wrap"
  }, [_c('div', {
    staticClass: "from-to"
  }, [_c('md-input-container', [_c('label', {
    attrs: {
      "for": "delete-page-from"
    }
  }, [_vm._v("From ")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "id": "delete-page-from",
      "type": "number",
      "readonly": "",
      "min": "1",
      "max": _vm.totalPages
    },
    on: {
      "blur": _vm.deleteValidateNumber
    },
    model: {
      value: (_vm.delete_page_from),
      callback: function($$v) {
        _vm.delete_page_from = $$v
      },
      expression: "delete_page_from"
    }
  })], 1), _vm._v(" "), _c('md-input-container', [_c('label', {
    attrs: {
      "for": "delete-page-to"
    }
  }, [_vm._v("To ")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "id": "delete-page-to",
      "type": "number",
      "readonly": "",
      "min": "1",
      "max": _vm.totalPages
    },
    on: {
      "blur": _vm.deleteValidateToNumber
    },
    model: {
      value: (_vm.delete_page_to),
      callback: function($$v) {
        _vm.delete_page_to = $$v
      },
      expression: "delete_page_to"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "comm-error"
  }, [(_vm.deleteErrorFromMessage) ? _c('p', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.deleteErrorFromMessage))]) : _vm._e(), _vm._v(" "), (_vm.deleteErrorToMessage) ? _c('p', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.deleteErrorToMessage))]) : _vm._e()])]), _vm._v(" "), _c('md-button', {
    staticClass: "md-warn md-raised",
    on: {
      "click": _vm.deletePages
    }
  }, [_vm._v("Delete Page(s)")])], 1)], 1)])]), _vm._v(" "), _c('md-dialog', {
    ref: "savedDraftThumbnailDialog",
    on: {
      "close": _vm.savedDraftThumbnailDialogCloseOutside
    }
  }, [_c('md-dialog-content', {
    staticStyle: {
      "padding": "24px"
    }
  }, [_c('p', {
    staticStyle: {
      "margin-bottom": "16px"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.getDeletePagesConfirmContent())
    }
  }), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "16px",
      "font-weight": "bold"
    }
  }, [_vm._v("\n                Cuelist recommends creating a backup before applying any changes.\n            ")]), _vm._v(" "), (_vm.project.autoSaveCap === true) ? _c('p', {
    staticStyle: {
      "margin-top": "12px"
    }
  }, [_vm._v("\n                Cuelist keeps your last 10 page-change saves.\n            ")]) : _vm._e()]), _vm._v(" "), _c('md-dialog-actions', {
    staticStyle: {
      "display": "flex",
      "justify-content": "flex-end",
      "padding": "16px"
    }
  }, [_c('md-button', {
    staticClass: "md-default",
    on: {
      "click": _vm.savedDraftThumbnailDialogClose
    }
  }, [_vm._v("\n                Cancel\n            ")]), _vm._v(" "), _c('md-button', {
    staticClass: "md-accent",
    on: {
      "click": function($event) {
        return _vm.onDialogClose('proceedWithoutSaving')
      }
    }
  }, [_vm._v("\n                Proceed Without Saving\n            ")]), _vm._v(" "), _c('md-button', {
    staticClass: "md-primary md-raised",
    on: {
      "click": function($event) {
        return _vm.onDialogClose('saveAndContinue')
      }
    }
  }, [_vm._v("\n                Save & Continue\n            ")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-28526c18","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modals/delete-page.vue
// module id = 1217
// module chunks = 21